<template>
      <div id="app">
            
            <router-view :key="key"></router-view>
      </div>
</template>

<script>
      export default {
            name: 'App',
            computed: {
                  key() {
                        return this.$route.path + Math.random();
                  }
            },
            methods: {
                  isWeiXin: function () {
                        var ua = window.navigator.userAgent.toLowerCase();
                        console.log(ua);//mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
                        if (ua.match(/MicroMessenger/i) == 'micromessenger' && ua.match(/WindowsWechat/i) != 'windowswechat' && ua.match(/WechatDevTools/i) != 'wechatdevtools') {
                              return true;
                        } else {
                              return false;
                        }
                  },
                  isMobile: function () {
                        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
                        console.log(flag);
                        return flag;
                  },
            },
            mounted() {
                  /*
                  if (this.isWeiXin()) {
                        alert('请用手机浏览器访问');
                        window.location.href = 'http://mychartered.org/';
                        //console.log(" 是来自微信内置浏览器");
                        //alert(" 是来自微信内置浏览器");
                  } else {
                        //console.log(" 是来NO自微信内置浏览器");
                        //alert(" 是来NO自微信内置浏览器");
                  }
                  
                  if (this.isMobile()) {
                        //移动端
                        document.getElementsByTagName('body')[0].className = 'enlarged'
                        console.log("yidong")
                  } else {
                        //非移动端
                  }
                  
                  */
            }

      }
</script>

<style>
      .swal2-title {
            font-size: 20px !important;
      }
</style>



// WEBPACK FOOTER //
// src/App.vue